import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import AuthProvider from "../context/AuthProvider";
import Header from './Header/Header';
import Home from './Content/Home/Home';
import SignUp from './Content/SignUp/SignUp';
import SignIn from './Content/SignIn/SignIn';
import AboutUs from './Content/AboutUs/AboutUs';
import ForgotPassword from './Content/ForgotPassword/ForgotPassword';
import CreatePassword from './Content/ForgotPassword/CreatePassword';
import CoachingHome from './Content/CoachingHome/CoachingHome';
import ContactUs from './Content/ContactUs/ContactUs';
import PrivateRoute from './PrivateRoute';
import ChangePassword from './Content/ChangePassword/ChangePassword';
import UpdateProfile from './Content/UpdateProfile/UpdateProfile';
import Admin from './Content/Admin/Admin';
import MarketDashboard from './Content/MarketDashboard/MarketDashboard';
import PatternRecognition from './Content/PatternRecognition/PatternRecognition';
import TradeRecommendations from './Content/TradeRecommendation/TradeRecommendations';
import SwingTrades from './Content/SwingTrades/SwingTrades';
import { MemoizedFooter } from './Footer/Footer';
import PrivacyPolicy from './Footer/Privacy/Privacy';
import TermsOfUse from './Footer/TermsOfUse/TermsOfUse';
import Blogs from './Content/Blogs/Blogs';
import ChartGenerate from './Content/MarketDashboard/ChartGenerate';
import './styles.css';
import AdvancedCharting from './Content/AdvancedCharting/AdvancedCharting';
import useIsSmallScreen from '../hooks/useIsSmallScreen';

const Layout = ({ children }) => {
    const location = useLocation();
    const isSmallScreen = useIsSmallScreen();
    const shouldHideForFullScreen = ['/chart-render'].includes(location.pathname)
        || (location.pathname === '/advancedCharting' && !isSmallScreen);
    const showHeaderFooter = !['/sign-in', '/sign-up'].includes(location.pathname)
        && !shouldHideForFullScreen
        && location.pathname.split('/')[1] !== 'activateUser'
        && location.pathname.split('/')[1] !== 'subscribeUser'
        && location.pathname.split('/')[1] !== 'unsubscribeUser';
    return (
        <>
            {showHeaderFooter && <Header />}
            {children}
            {showHeaderFooter && <MemoizedFooter />}
        </>
    );
};

const App = () => (
    <Router>
        <AuthProvider>
            <Routes>
                <Route
                    path="*"
                    element={
                        <Layout>
                            <Routes>
                                <Route exact path="/" element={<Home />} />
                                <Route exact path="/home" element={<Home />} />
                                <Route path="/activateUser/:uniqueId" element={<SignIn />} />
                                <Route path="/unsubscribeUser/:emailId" element={<SignIn />} />
                                <Route path="/subscribeUser/:emailId" element={<SignIn />} />
                                <Route path="/changePassword/:uniqueId" element={<CreatePassword />} />
                                <Route exact path="/sign-up" element={<SignUp />} />
                                <Route exact path="/sign-in" element={<SignIn />} />
                                <Route exact path="/about-us" element={<AboutUs />} />
                                <Route exact path="/forgot-password" element={<ForgotPassword />} />
                                <Route exact path="/change-password" element={<ChangePassword />} />
                                <Route exact path="/update-profile" element={<UpdateProfile />} />
                                <Route exact path="/1-1-Coaching" element={<CoachingHome />} />
                                <Route exact path="/contact-us" element={<ContactUs />} />
                                <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                                <Route exact path="/terms-of-use" element={<TermsOfUse />} />
                                <Route exact path="/blogs" element={<Blogs />} />
                                <Route exact path="/chart-render" element={<ChartGenerate />} />
                                <Route exact path="/advancedCharting" element={<AdvancedCharting />} />
                                <Route element={<PrivateRoute />}>
                                    <Route path="/" element={<Home />}>
                                        <Route index element={<MarketDashboard />} />
                                        <Route path="marketDashboard" element={<MarketDashboard />} />
                                        <Route path="patternRecognition" element={<PatternRecognition />} />
                                        <Route path="futuresTrades" element={<TradeRecommendations />} />
                                        <Route path="swingTrades" element={<SwingTrades />} />
                                    </Route>
                                    <Route path="/admin/ctdev" element={<Admin/>} />
                                </Route>
                            </Routes>
                        </Layout>
                    }
                />
            </Routes>
        </AuthProvider>
    </Router>
);

export default App;
